import { createApi } from '@reduxjs/toolkit/query/react';
import { z } from 'zod';
import { baseQuery } from './baseQuery';
import { validateResponse } from './validateResponse';

export const TargetingV3StubSchema = z.object({ message: z.string() });
export type TargetingV3Stub = z.infer<typeof TargetingV3StubSchema>;

export const targetingV3Api = createApi({
    reducerPath: 'targetingV3Api',
    baseQuery,
    endpoints: (builder) => ({
        getTargetingV3: builder.query<TargetingV3Stub, void>({
            query: () => 'api/v3/targeting',
            transformResponse: validateResponse(TargetingV3StubSchema),
        }),
    }),
});

export const { useGetTargetingV3Query } = targetingV3Api;
